import apiClient from "../../../service/apiClient";
import { DOCUMENT_ENDPOINTS } from "../../../app/apiEndpoints";

export const getInvestorsByContact = (contactId) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_INVESTORS_BY_CONTACT, {
    params: {
      contactId,
      addSelect: true,
      isAsset: false,
    },
  });

export const getEntitiesByInvestor = (investorId, contactId) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_ENTITIES_BY_INVESTOR, {
    params: { investorId, contactId, documentGroup: 0, addSelect: true },
  });

export const getCategoryByEntity = (investorId, entityId, entityTypeId, contactId) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_CATEGORY_BY_ENTITY, {
    params: {
      investorId,
      entityId,
      entityTypeId,
      ContactId: contactId,
    },
  });

export const getDocumentsByEntity = ({
  investorId,
  entityId,
  entityTypeId,
  fromDate,
  toDate,
  documentName,
  categoryType,
  isCategoryExists,
  contactId,
  userId,
  appRoleId,
}) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_DOCUMENTS_BY_ENTITY, {
    params: {
      investorId,
      entityId,
      entityTypeId,
      fromDate,
      toDate,
      documentName,
      categoryType,
      isCategoryExists,
      contactId,
      userId,
      appRoleId,
      documentGroup: 0,
    },
  });

// direct available backend download APIs
export const downloadDocumentBlob = (documentId, isRejected = false, userId = 0, appRoleId = 0) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_DOCUMENT_BY_DOCUMENT_ID, {
    params: { documentId, isRejected, userId, appRoleId },
    responseType: "blob",
  });

export const getDocumentNameById = (documentId, isRejected = false) =>
  apiClient.get(`${DOCUMENT_ENDPOINTS.GET_DOCUMENT_NAME_BY_DOCUMENT_ID}/${documentId},${isRejected}`);

// blob helpers
export const openBlobInNewTab = (blob) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};

// keep these until backend gives direct merge-pdf/zip swagger endpoints
const makeUrl = (url, params) => apiClient.getUri({ url, params });

export const getClientDocumentsSinglePDFDownloadUrl = (documentIds, fileName, userId, appRoleId) =>
  makeUrl(DOCUMENT_ENDPOINTS.GET_CLIENT_DOCUMENTS_SINGLE_PDF_DOWNLOAD, {
    documentIds,
    fileName,
    userId,
    appRoleId,
  });

export const getDocumentAsSingleZipDownloadUrl = (documentIds, fileName, userId, appRoleId) =>
  makeUrl(DOCUMENT_ENDPOINTS.GET_DOCUMENT_AS_SINGLE_ZIP_DOWNLOAD, {
    documentIds,
    fileName,
    userId,
    appRoleId,
  });


export const getDocumentsCustomize = (PageId, UserId, Name, isResearchDocument = false) =>
  apiClient.get(
    `${DOCUMENT_ENDPOINTS.GET_DOCUMENTS_CUSTOMIZE}/${PageId},${UserId},${encodeURIComponent(Name)},${isResearchDocument}`
  );

// Save customize for all pages (Statement/Documents/Research) through common backend endpoint
export const saveGridCustomize = (payload) =>
  apiClient.post(DOCUMENT_ENDPOINTS.UPDATE_GRID_CUSTOMIZE, payload);

export const downloadDocumentsZipBlob = (
  documentIds,
  userId = 0,
  appRoleId = 0,
  fileName = "Documents",
  isRejected = false
) =>
  apiClient.get(DOCUMENT_ENDPOINTS.GET_WEB_DOCUMENT_AS_SINGLE_ZIP, {
    params: {
      documentIds: Array.isArray(documentIds) ? documentIds.join(",") : String(documentIds),
      userId,
      appRoleId,
      fileName,
      isRejected,
    },
    responseType: "blob",
  });
